import breakpoint from '@/client/components/theme/breakpoint'
import styled from 'styled-components'

export const PostTagWrap = styled.div`
  margin: 0 -0.25rem;
`
export const SearchSetup = styled.div`
  display: none;
  @media (min-width: ${breakpoint.lg2}) {
    display: block;
  }
`
